import { useState, useEffect } from "react";
import APIKey from "./APIKey";
import RegenerateAPIKey from "./RegenerateAPIKey";
import PermissionGate from "../layout/PermissionGate";

const APIKeys = ({ id }) => {
  const [keys, setKeys] = useState([]);
  const [regenerate, setRegenerate] = useState(false);
  const [branchId, setBranchId] = useState(null);
  const token = localStorage.getItem("token");

  const fetchAPIKeys = async () => {
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `get-api-keys-by-merchant?merchantId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.code === 1) {
          setKeys(res.data.data);
        }
      })
      .catch(console.error);
  };
  const regenerateAPIkey = async (branchId) => {
    axios
      .patch(
        process.env.REACT_APP_API_ENDPOINT +
          `regenerate-api-key?branchId=${branchId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.code === 1) {
          fetchAPIKeys();
        }
      })
      .catch(console.error);
  };
  const downloadAPIKeys = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}download-api-keys?merchantId=${id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const timestamp = Date.now();
      const filename = `api_keys_${timestamp}.xlsx`;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Export failed:", err);
    }
  };

  useEffect(() => {
    fetchAPIKeys();
  }, [id]);
  return (
    <>
      <div className="row g-5 g-lg-10 mt-4">
        {/*begin::Col*/}
        <div className="col p-0 mb-xl-10">
          <div className="d-flex justify-content-between align-items-center text-dark fw-bold m-0 fs-3 mb-5">
            <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
              Branch API Keys
            </h1>
            <PermissionGate
              required={`download_merchant_api_keys`}
              fallback={<></>}
            >
              <button onClick={downloadAPIKeys} className="btn btn-primary">
                <i className="bi-duotone bi-download mb-1"></i>
                Download All
              </button>
            </PermissionGate>
          </div>
          {/*begin::Tables Widget*/}
          <PermissionGate required={`view_merchant_api_keys`}>
            <div className="card">
              <div className="card-body">
                {keys?.length === 0 ? (
                  <div className="text-center w-100">
                    <img
                      className="w-25 mx-auto py-20"
                      src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                      alt="no-content"
                    />
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                      <thead>
                        <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                          <th className="text-center min-w-120px">
                            Branch Name
                          </th>
                          <th className="text-center min-w-120px">API Key</th>
                          <th className="text-center min-w-120px">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="text-gray-600 fw-semibold">
                        {keys &&
                          keys.map((key, index) => {
                            return (
                              <APIKey
                                item={key}
                                key={index}
                                setRegenerate={setRegenerate}
                                setBranchId={setBranchId}
                              />
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              {/*begin::Body*/}
            </div>
          </PermissionGate>
          {/*end::Tables Widget*/}
        </div>
        {/*end::Col*/}
      </div>
      {regenerate && (
        <RegenerateAPIKey
          regenerate={regenerate}
          setRegenerate={setRegenerate}
          regenerateAPIkey={regenerateAPIkey}
          branchId={branchId}
        />
      )}
    </>
  );
};

export default APIKeys;
